module.exports = __webpack_public_path__ + "static/media/iarc_logo.c0dbcd2a.gif";